import { computed, ref, onUnmounted } from 'vue';
import useServerTime from './useServerTime';

const useRealTime = () => {
  const { getServerTime } = useServerTime();

  const time = ref(getServerTime());

  const interval = ref(setInterval(() => {
    time.value = getServerTime();
  }, 1000));

  const realTime = computed(() => time.value);

  onUnmounted(() => {
    clearInterval(interval.value);
  });

  return {
    realTime,
  };
};

export default useRealTime;
